/* unplugin-vue-components disabled */import { render } from "./root-layout.vue?vue&type=template&id=840900f2&scoped=true"
import script from "./root-layout.vue?vue&type=script&lang=js"
export * from "./root-layout.vue?vue&type=script&lang=js"

import "./root-layout.vue?vue&type=style&index=0&id=840900f2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840900f2"],['__file',"src/pages/root-layout/root-layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "840900f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('840900f2', __exports__)) {
    api.reload('840900f2', __exports__)
  }
  
  module.hot.accept("./root-layout.vue?vue&type=template&id=840900f2&scoped=true", () => {
    api.rerender('840900f2', render)
  })

}


export default __exports__